import CustomerContactDelete from './CustomerContactDelete';

export default CustomerContactDelete;
